export default __webpack_public_path__ + "static/media/11.32cc6b1b.jpg";